module.exports = __webpack_public_path__ + "media/assets/faria_products/MPD_PYP-1ce75509f8e943ac93f64b8f66f934414adac37e925ced6c3b9459706a4df704.png";